module.exports = __webpack_public_path__ + "img/utilisateur-bordeaux.6b53433b.svg";